// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"09a2dc34","129":"09a2dc34"}[chunkId] + ".chunk.css";
};